import { CSSProperties } from 'react';

export const flexCenteredParentContainerStyles: CSSProperties = {
  display: 'flex',
  height: '100%',
  overflowY: 'auto',
  boxSizing: 'border-box',
};

export const flexCenteredContentContainerStyles: CSSProperties = {
  margin: 'auto 0',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};
